/**
 * Product fees. Keep in sync with
 * betMateBackEnd/src/constants/fees.js and BetBond/src/config/fees.js.
 */

/** P2P settlement commission on the winning side’s profit (gross payout − stake). */
export const P2P_PLATFORM_FEE_RATE = 0.07;
export const P2P_PLATFORM_FEE_PERCENT = 7;

/** COIN charged to publish a community tip. */
export const CREATE_TIP_COST_COIN = 100;

export function p2pFeeFromGrossAndStake(grossPayout, stake) {
  const gross = Number(grossPayout) || 0;
  const s = Number(stake) || 0;
  const profit = Math.max(0, gross - s);
  const fee = profit * P2P_PLATFORM_FEE_RATE;
  return { profit, fee, net: gross - fee };
}
